import { newMathFormatWrapper } from '@gp/utils/common';

const RANGE_NUM_VALUE_JOINER = '~';

const KMB_FIELD_REGS = [
  /^Development Cost by Month \(All Months - (.+) Actual\)$/,
  /^Development Cost by Month \(All Months - (.+) Budget\)$/,
  /^Development Cost by Month \(All Months - (.+) Forecast\)$/,
  /^Spend to Date \(\$\)$/,
  /^(.+) Development Cost \(\$\)$/,
  /^(.+) Development Cost Actual \(\$\)$/,
  /^(.+) Development Cost Budget \(\$\)$/,
  /^(.+) Development Cost Forecast \(\$\)$/,
  /^Approved Development Actual \(\$\)$/,
  /^Approved Development Budget \(\$\)$/,
  /^Approved Development Forecast \(\$\)$/,
  /^Net Profit Ratio$/,
  /^Y1 Copy Sales Forecast(\(.+\))?$/,
  /^Y1 Revenue Forecast \(\$\)(\(.+\))?$/,
  /^Y3 Copy Sales Forecast(\(.+\))?$/,
  /^Y3 Revenue Forecast \(\$\)(\(.+\))?$/,
];

export const formatFieldValue = (field?: string, value?: string, placeholder = '-'): string => {
  const valueTrim = value?.trim() || '';
  if (!valueTrim) return placeholder;
  if (!field) return valueTrim;

  if (KMB_FIELD_REGS.some((reg) => reg.test(field))) {
    const values = valueTrim.split(RANGE_NUM_VALUE_JOINER);
    const valuesFormatted = values.map((valueItem) => {
      if (Number.isNaN(Number(valueItem))) return valueItem;
      return String(newMathFormatWrapper(valueItem, true));
    });
    return valuesFormatted.join(RANGE_NUM_VALUE_JOINER);
  }

  return valueTrim || placeholder;
};
